import type { SupportedFormat } from '@/shared/config/funnel/types';

export const FORMAT_MAPPER: Record<SupportedFormat, Intl.NumberFormatOptions> = {
  currency: {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  },
};
